import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateLayoutState from './layout';

export default (state = initialState, action) => chooseReducer(state, action, updateLayoutState);
